// Import browser sentry and rn sentry for the type

import { ELoggerCategory, ELoggerLevel } from './logger.types';

export interface ILoggerStrategy {
  handleException(exception: Error, extraInfo: object): void;
  log(message: string, options: ILoggerOption): void;
  logWithMessageAndData(
    message: string,
    data: unknown,
    options: ILoggerOption
  ): void;
  enrichWithTag(key: string, value: string): void;
  enrichWithUser(user: { id: string }): void;
  addHint(
    category: ELoggerCategory,
    message: string,
    options: ILoggerOption
  ): void;
}

export interface ILoggerOption {
  level?: ELoggerLevel;
}

export interface IExceptionConfig {
  rethrow?: boolean;
  extraInfo?: object;
}

class LoggerService {
  private _strategy: ILoggerStrategy;

  public set strategy(strategy: ILoggerStrategy) {
    this._strategy = strategy;
  }
  public get strategy() {
    if (!this._strategy) {
      console.trace();
      throw new Error('No logger strategy configured');
    }

    return this._strategy;
  }

  public handleException = (
    error: Error,
    { rethrow = false, extraInfo = {} }: IExceptionConfig = {}
  ): void => {
    this.strategy.handleException(error, extraInfo);

    if (rethrow) throw error;
  };

  public log(
    message: string,
    { level = ELoggerLevel.Error }: ILoggerOption = {}
  ) {
    this.strategy.log(message, { level });
  }

  public logWithMessageAndData(
    message: string,
    data: unknown,
    options: ILoggerOption = {}
  ) {
    this.strategy.logWithMessageAndData(message, data, options);
  }

  public enrichWithUser = (userId: string): void => {
    this.strategy.enrichWithUser({ id: userId });
  };

  public enrichWithTag = (key: string, value: string): void => {
    this.strategy.enrichWithTag(key, value);
  };

  public addHint = (
    category: ELoggerCategory,
    message: string,
    { level = ELoggerLevel.Info }: ILoggerOption = {}
  ): void => {
    this.strategy.addHint(category, message, { level });
  };
}

export const logger = new LoggerService();
